import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AdventActions } from '../../store/advent/actions/advent.actions';
import { HelpersService } from '../helpers/helpers.service';
import { KeystoneService } from '../keystone/keystone.service';

@Injectable({
  providedIn: 'root',
})
export class AdventService {
  private today!: number;
  private userAdvent: string = 'standart';
  private adventVariant: string = '';
  private adventBonus: string = '';

  constructor(
    private store: Store,
    private helper: HelpersService,
    private keystone: KeystoneService
  ) {}

  public initializeAdvent(date: string, userTags: string[]) {
    let fundistDate: Date = new Date(date);
    //For testing purposes:
    if (sessionStorage.getItem('adventDate')) {
      fundistDate = new Date(sessionStorage.getItem('adventDate') as string);
    }
    if (this.today === fundistDate.getDate()) return;
    const adventStartDate: Date = new Date('Wed, 17 Dec 2025 00:00:01 GMT');
    const adventEndDate: Date = new Date('Wed, 24 Dec 2025 23:59:59 GMT');
    const isDateInRange: boolean = fundistDate >= adventStartDate && fundistDate <= adventEndDate;
    const forbiddenTags: string[] = [
      'Security Block',
      'Gambling problem',
      'ForbidBonuses',
      'Bonushunter',
      'Cheater',
      'Problematic',
      'Block CC',
    ];
    const hasForbiddenTag = forbiddenTags.some((tag) => userTags.includes(tag));
    const isAdvent: boolean = isDateInRange && !hasForbiddenTag;
    this.store.dispatch(AdventActions['[advent]SetAdvent']({ data: isAdvent }));
    if (isAdvent) {
      this.today = fundistDate.getDate();
      this.store.dispatch(AdventActions['[advent]SetAdventDate']({ data: fundistDate.getDate() }));
      this.userAdvent = this.getUserAdventByTag(userTags);
      const lang: string = this.helper.getCookie('userlang');
      this.getAdventFromKeystone(lang);
    }
  }

  public getAdventFromKeystone(lang: string) {
    if (!this.today) return;
    const adventDay = this.userAdvent + this.today.toString();
    this.keystone.getAdvent(lang, this.userAdvent, adventDay, this.adventVariant).subscribe((response) => {
      this.store.dispatch(AdventActions['[advent]SetKeystoneAdvent']({ data: response }));
      if (this.adventBonus !== response?.bonusId) {
        this.adventBonus = response?.bonusId;
        this.store.dispatch(AdventActions['[advent]SetAdventBonus']({ data: this.adventBonus }));
      }
    });
  }

  private getUserAdventByTag(tags: string[]): string {
    if (tags.includes('Super VIP')) return 'super-vip';
    if (tags.includes('CRVIP')) return 'vip';
    if (this.today === 17 || this.today === 24) {
      this.getAdventVariant(tags);
    }
    return 'standart';
  }

  private getAdventVariant(tags: string[]) {
    if (tags.includes('DecAdv1')) {
      this.adventVariant = 'A';
      return;
    }
    if (tags.includes('DecAdv2')) {
      this.adventVariant = 'B';
      return;
    }
    if (tags.includes('DecAdv3')) {
      this.adventVariant = 'C';
      return;
    }
    if (tags.includes('DecAdv4')) {
      this.adventVariant = 'D';
    }
  }
}
